import {
  MobileSelectionList,
  MobileSelectionListItem,
} from "common/components/MobileSelectionList";
import ProfileHeading from "common/components/ProfileHeading";
import { Tag } from "common/components/ui/Tag";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";

import { LIST_LEADS_COLUMNS } from "../../../../constants";
import LeadListLeadSources from "../LeadListLeadSources";

import type { ListLead } from "../../../../types";

interface MobileListProps {
  listId: string;
  leads: ListLead[];
  isLoading: boolean;
  pageSize: number;
  totalItemCount: number;
  selectedLeads: ListLead[];
  setSelectedLeads: (selectedLeads: ListLead[]) => void;
}

export default function MobileList({
  listId,
  leads,
  isLoading,
  pageSize,
  totalItemCount,
  selectedLeads,
  setSelectedLeads,
}: MobileListProps) {
  const { permissions } = useSelectedWorkspaceContext();

  return (
    <MobileSelectionList
      title="Leads"
      data={leads || new Array(pageSize).fill(null)}
      selection={selectedLeads}
      onSelectionChange={
        isLoading
          ? undefined
          : (newSelection) =>
              setSelectedLeads(newSelection === "all" ? leads : newSelection)
      }
      allItems={LIST_LEADS_COLUMNS}
      totalDataCount={totalItemCount}
      canSelectAll={false}
    >
      {(lead, listItemProps) => {
        const {
          id,
          picture_url,
          full_name,
          occupation,
          blacklisted,
          company_blacklisted,
          source_ids,
        } = lead;

        return (
          <MobileSelectionListItem
            {...listItemProps}
            relativeTo={
              permissions.includes("leads_full") ? `leads/${id}` : undefined
            }
          >
            {isLoading ? (
              <ProfileHeading
                isLoading
                extraComponent={
                  <LeadListLeadSources
                    listId={listId}
                    sourceIds={source_ids}
                    isLoading
                  />
                }
              />
            ) : (
              <ProfileHeading
                fullName={full_name}
                occupation={occupation}
                pictureUrl={picture_url}
                isLoading={isLoading}
                extraComponent={
                  blacklisted || company_blacklisted ? (
                    <Tag variant="danger" className="shrink-0">
                      Blacklisted
                    </Tag>
                  ) : (
                    <LeadListLeadSources
                      listId={listId}
                      sourceIds={source_ids}
                      isLoading={isLoading}
                    />
                  )
                }
              />
            )}
          </MobileSelectionListItem>
        );
      }}
    </MobileSelectionList>
  );
}
